import { useEffect, useState } from 'react'
import { lookupOrganizations } from './org-search-api'

// The names of the organizations these ids name (owner 2026-10-13): asked
// of content's organization search by id (remembered across the page),
// never by loading every organization. Map id -> { id, name, personal };
// an id not (yet) known is absent.
export const useOrganizationNames = ids => {
  const key = [...new Set((ids || []).map(Number).filter(n => n > 0))].sort((a, b) => a - b).join(',')
  const [names, setNames] = useState(() => new Map())

  useEffect(() => {
    if (!key) {
      setNames(new Map())
      return undefined
    }
    let live = true
    lookupOrganizations(key.split(',').map(Number)).then(found => live && setNames(found), () => {})
    return () => {
      live = false
    }
  }, [key])

  return names
}

// One organization's name, or undefined until it is known.
export const useOrganizationName = id => {
  const found = useOrganizationNames(id ? [id] : []).get(Number(id))
  return found ? found.name : undefined
}
